/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PermissionDto from './PermissionDto';

/**
 * The RoleObjectDto model module.
 * @module model/RoleObjectDto
 * @version v1.0.0
 */
class RoleObjectDto {
    /**
     * Constructs a new <code>RoleObjectDto</code>.
     * @alias module:model/RoleObjectDto
     */
    constructor() { 
        
        RoleObjectDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RoleObjectDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RoleObjectDto} obj Optional instance to populate.
     * @return {module:model/RoleObjectDto} The populated <code>RoleObjectDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RoleObjectDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('permissions')) {
                obj['permissions'] = ApiClient.convertToType(data['permissions'], [PermissionDto]);
            }
            if (data.hasOwnProperty('priority')) {
                obj['priority'] = ApiClient.convertToType(data['priority'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * role description
 * @member {String} description
 */
RoleObjectDto.prototype['description'] = undefined;

/**
 * role id
 * @member {Number} id
 */
RoleObjectDto.prototype['id'] = undefined;

/**
 * role name
 * @member {String} name
 */
RoleObjectDto.prototype['name'] = undefined;

/**
 * permission list
 * @member {Array.<module:model/PermissionDto>} permissions
 */
RoleObjectDto.prototype['permissions'] = undefined;

/**
 * Priority
 * @member {Number} priority
 */
RoleObjectDto.prototype['priority'] = undefined;






export default RoleObjectDto;

